import { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface AvatarRowProps {
  avatar: ReactNode;
  label: string;
  secondary?: string;
}

export const AvatarRow = ({ avatar, label, secondary }: AvatarRowProps) => (
  <li className="flex items-center gap-2 rounded-md px-1 py-1 hover:bg-accent/40">
    {avatar}
    <div className="flex min-w-0 flex-1 flex-col">
      <span className={cn("truncate text-xs text-foreground", secondary && "font-semibold")}>
        {label}
      </span>
      {secondary && <span className="truncate text-[11px] text-muted-foreground">{secondary}</span>}
    </div>
  </li>
);
